import React, {useState} from "react";
import TimeseriesGraphs from "../../../../components/Graph/TimeseriesGraphs";
import StationGraphs from "../../../../components/Graph/StationGraphs";
import TimeseriesComparisonGraphs from "../../../../components/Graph/TimeseriesComparisonGraphs";
import MDBox from "materialDashboard/components/MDBox";
import {ButtonGroup} from "@mui/material";
import {useTranslation} from "react-i18next";
import useActiveFeature from "./useActiveFeature";
import FeatureSelectionChips from "./FeatureSelectionChips";
import useComparisonMode from "./useComparisonMode";
import ComparisonChip from "./ComparisonChip";
import Stack from "@mui/material/Stack";
import {subDays, startOfDay, endOfDay, addDays} from "date-fns";
import {getSeason} from "../../../../components/Graph/utils";
import {SINGLE_DAY_MODE} from "../FiltersPanel/TemporalFilters";
import MDButton from "materialDashboard/components/MDButton";

const Model1Panel = ({selectedFeatures, onDeSelectFeature, temporalState}) => {
    const {t} = useTranslation(["webgis"]);
    const {activeFeatureId, setActiveFeatureId, activeFeature} = useActiveFeature(selectedFeatures);
    const [showHistoricalGraph, setshowHistoricalGraph] = useState(false);
    const [comparisonMode, setComparisonMode] = useComparisonMode(selectedFeatures);
    const [selectedRange, setSelectedRange] = useState("season");

    const isSingleDay = temporalState.mode === SINGLE_DAY_MODE;
    const season = getSeason(temporalState.date);

    const handleSetActiveFeature = (id) => {
        setComparisonMode(false);
        setActiveFeatureId(id);
    }

    const getRangeFromDays = (days) => {
        return {
            datetimeGte: startOfDay(subDays(temporalState.date, days)),
            datetimeLte: endOfDay(addDays(temporalState.date, days)),
        }
    }

    const rangeFromFilter = {
        datetimeGte: startOfDay(temporalState.filterDateGte),
        datetimeLte: endOfDay(temporalState.filterDateLte),
    }
    const rangeSeason = {
        datetimeGte: startOfDay(new Date(season, 9, 1)), // Oct 1st
        datetimeLte: endOfDay(new Date(season + 1, 8, 30)), // Sept 30th
    }
    let selectedRangeValue;
    if (isSingleDay){
        if (selectedRange === "15d") {
            selectedRangeValue = getRangeFromDays(15);
        } else if (selectedRange === "30d") {
            selectedRangeValue = getRangeFromDays(30);
        } else if (selectedRange === "season") {
            selectedRangeValue = rangeSeason;
        } else {
            console.error("Invalid selected range value:", selectedRange);
            selectedRangeValue = rangeSeason;
        }
    } else {
        selectedRangeValue = rangeFromFilter;
    }


    const range15IsSelected = selectedRange === "15d";
    const range30IsSelected = selectedRange === "30d";
    const rangeSeasonIsSelected = selectedRange === "season";

    if (!activeFeatureId) {
        return null;
    }

    const stationId = activeFeature?.properties?.id;

    return (
        <MDBox>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <FeatureSelectionChips
                        selectedFeatures={selectedFeatures}
                        activeFeatureId={comparisonMode ? null : activeFeatureId}
                        setActiveFeatureId={handleSetActiveFeature}
                        onDeSelectFeature={onDeSelectFeature}
                    />
                    {!showHistoricalGraph && <ComparisonChip
                        disabled={selectedFeatures.length <= 1}
                        comparisonMode={comparisonMode}
                        setComparisonMode={setComparisonMode}
                    />}
                </Stack>
                <Stack direction="row" spacing={1}>
                    {isSingleDay && !showHistoricalGraph && (
                        <ButtonGroup>
                            <MDButton onClick={() => setSelectedRange("15d")} variant={range15IsSelected ? 'contained' : 'outlined'} color="info" size="small">
                                {t('model1Panel.15d')}
                            </MDButton>
                            <MDButton onClick={() => setSelectedRange("30d")} variant={range30IsSelected ? 'contained' : 'outlined'} color="info" size="small">
                                {t('model1Panel.30D')}
                            </MDButton>
                            <MDButton onClick={() => setSelectedRange("season")} variant={rangeSeasonIsSelected ? 'contained' : 'outlined'} color="info" size="small">
                                {t('model1Panel.season')}
                            </MDButton>
                        </ButtonGroup>
                    )}
                    <MDButton variant="outlined"
                              color="info"
                              onClick={() => setshowHistoricalGraph(!showHistoricalGraph)}
                              size="small"
                              disabled={!stationId || comparisonMode}
                    >
                        {showHistoricalGraph ? t('model1Panel.back') : t('model1Panel.historicalData')}
                    </MDButton>
                </Stack>
            </Stack>

            {showHistoricalGraph && stationId ? (
                <StationGraphs stationId={stationId} />
            ) : comparisonMode ? (
                <TimeseriesComparisonGraphs stationIds={selectedFeatures.map(f => f.properties.id)}
                                            dateTimeGte={selectedRangeValue?.datetimeGte}
                                            dateTimeLte={selectedRangeValue?.datetimeLte}
                                            highlightedDate={isSingleDay ? temporalState.date : null}
                />
            ) : (
                <TimeseriesGraphs stationId={activeFeatureId}
                                  dateTimeGte={selectedRangeValue?.datetimeGte}
                                  dateTimeLte={selectedRangeValue?.datetimeLte}
                                  station={activeFeature?.properties}
                                  highlightedDate={isSingleDay ? temporalState.date : null}
                />
                )}
        </MDBox>
    );
}

export default Model1Panel;
